export function docReady(callback) {
    document.addEventListener('DOMContentLoaded', callback);
}

export default {
    docReady
};
